import React, { useEffect } from "react";
import axios from 'axios'
import styled from "styled-components";
import {Modal} from "../components";
import { useState } from "react";
import { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import { url } from "../constants";

const Button = styled.button`
  border:2px solid rgba(77,75,50,0.72);
  padding:10px;
  border-radius:10px;
  color:white;
  width:100%;
  margin-top:10px;
  font-size:16px;
  border:1px solid rgba(77,75,50,0.72);
  &:hover{
    cursor:pointer;
    color:black;
    background:#FCDA8B;
    box-shadow: 0px 0px 6px 5px rgba(77,75,50,0.72);
    border:1px solid #FCDA8B;
    transition: all 0.5s ease-in;
  }
  &:active{
    transform:scale(0.9);
  }
`

export default function StripeCheckoutHandler({data}) {
  const {formData, setFormData, clicked} = useContext(CartContext)
  const [userInfo, setUserInfo] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate()
  const handler = async (e) => {
    e.preventDefault();
    await axios({
      url:`${url}/api/create-checkout-session/`,
      method:'POST',
      data:{data, email:formData.email},
      headers:{"Content-Type":'application/json'}
    }).then(async(res) => {
      console.log(4545, res.data)
      localStorage.setItem('formData', JSON.stringify(formData))
      window.location.href = res.data.key
    }).catch(err => alert('something went wrong please try again'))
  }

  useEffect(()=>{
    localStorage.removeItem('formData')
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem("userInfo")) : null
    setFormData({
      fullName:userInfo?.last_name,
      email:userInfo?.email,
      number:'',
      address:'',
    })
    setUserInfo(userInfo)
    if(clicked){
      document.getElementById('strpieCheckoutHandler').click()
      setIsModalOpen(false)
    }
    // eslint-disable-next-line
  },[clicked])

    return(
    <section>
      <form className="d-flex justify-content-center" onSubmit={handler} method="POST" >
        <Button id='strpieCheckoutHandler' style={{display:'none'}} type="submit">
          Checkout
        </Button>
      </form>
      {clicked &&
        <div className="modal">
            <h4>wait we are initializing stripe</h4>
        </div>
      }
      {userInfo ? 
        <Modal isOpen={isModalOpen} setIsOpen={setIsModalOpen} data={formData} setData={setFormData}/>
        :
        <Button onClick={()=>navigate('/Authentication')}>Login</Button>
      }
    </section>
  );
}